/**
 * CreditChip — compact credit control status for pipeline rows.
 * Shows: last invoice date, outstanding amount, escalation stage colour.
 *
 * Props:
 *   invoiceDate       string  e.g. "2026-03-12"
 *   totalOutstanding   number  e.g. 3200
 *   escalationStage   string  e.g. "reminder_2"
 *   daysOverdue       number  e.g. 47
 */

const STAGE_COLOUR = {
  invoice_issued: "bg-teal",
  reminder_1: "bg-status-amber",
  call_1: "bg-status-amber",
  reminder_2: "bg-status-amber",
  call_2: "bg-status-amber",
  reminder_3: "bg-status-red",
  call_3: "bg-status-red",
  lba_sent: "bg-status-red",
  proceedings: "bg-status-red-dim",
};

function fmt(n) {
  return "\u00a3" + Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0 });
}

function shortDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export default function CreditChip({ invoiceDate, totalOutstanding, escalationStage, daysOverdue }) {
  if (!totalOutstanding && !escalationStage) return null;

  const stageColour = STAGE_COLOUR[escalationStage] || "bg-slate-600";
  const label = (escalationStage || "").replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

  return (
    <div className="flex items-center gap-2 text-[10px]">
      {invoiceDate && (
        <span className="text-slate-400">Inv: {shortDate(invoiceDate)}</span>
      )}
      {totalOutstanding > 0 && (
        <span className="text-status-amber font-medium">{fmt(totalOutstanding)} o/s</span>
      )}
      {daysOverdue > 0 && (
        <span className="text-status-red">{daysOverdue}d overdue</span>
      )}
      {escalationStage && (
        <span className={`px-1.5 py-0.5 rounded text-[9px] text-white ${stageColour}`}>
          {label}
        </span>
      )}
    </div>
  );
}
